module.exports = __webpack_public_path__ + "static/img/horizontalRotate.31ffd5b.svg";